import { Component, Input, OnInit } from '@angular/core';
import { CitiserviMAIDsQAReport } from 'src/app/models/services/qaReport';

@Component({
  selector: 'app-report-viewer-citiservi-ctvs',
  templateUrl: './report-viewer-citiservi-ctvs.component.html',
  styleUrls: ['./report-viewer-citiservi-ctvs.component.sass']
})
export class ReportViewerCitiserviCtvsComponent implements OnInit {

  @Input()
  public selectedReport: CitiserviMAIDsQAReport;
  
  constructor() { }

  ngOnInit(): void {
  }

}
